export const ALLOLDCARS = "ALLOLDCARS";
export const VIEWOVERVIEWBYOLDCAR = "VIEWOVERVIEWBYOLDCAR";
export const VIEWOLDCARBYID = "VIEWOLDCARBYID";
export const VIEWSPECIFICATIONBYOLDCAR = "VIEWSPECIFICATIONBYOLDCAR";
export const VIEWFETURESBYOLDCARID = "VIEWFETURESBYOLDCARID";
export const VIEWCARBYBRAND = "VIEWCARBYBRAND";
